import React, {Component} from 'react';

const shiftAware = WrappedComponent => {

    class ShiftAware extends Component {
        constructor(props) {
            super(props);

            this.state = {
                shiftLeftPressed: false,
                shiftRightPressed: false
            };

            this.mounted = false;
        }

        static KEY_DOWN_EVENT_NAME = 'keydown';
        static KEY_UP_EVENT_NAME = 'keyup';

        componentDidMount() {
            this.mounted = true;
            window.addEventListener(ShiftAware.KEY_DOWN_EVENT_NAME, this.keyDownHandler);
            window.addEventListener(ShiftAware.KEY_UP_EVENT_NAME, this.keyUpHandler);
        };

        componentWillUnmount() {
            window.removeEventListener(ShiftAware.KEY_DOWN_EVENT_NAME, this.keyDownHandler);
            window.removeEventListener(ShiftAware.KEY_UP_EVENT_NAME, this.keyUpHandler);
            this.mounted = false;
        }

        keyDownHandler = e => {
            const code = e.code ? e.code : e.key;

            switch (code) {
                case 'ShiftLeft':
                    this.setState({shiftLeftPressed: true});
                    break;
                case 'ShiftRight':
                    this.setState({shiftRightPressed: true});
                    break;
                default:
            }
        };

        keyUpHandler = e => {
            const code = e.code ? e.code : e.key;

            switch (code) {
                case 'ShiftLeft':
                    this.setState({shiftLeftPressed: false});
                    break;
                case 'ShiftRight':
                    this.setState({shiftRightPressed: false});
                    break;
                default:
            }
        };

        render() {
            const {shiftLeftPressed, shiftRightPressed} = this.state;
            const {props} = this;

            return (
                <WrappedComponent
                    shiftLeftPressed={shiftLeftPressed}
                    shiftRightPressed={shiftRightPressed}
                    shiftPressed={shiftLeftPressed || shiftRightPressed}
                    {...props}/>
            );
        }
    }

    return ShiftAware;
};

export default shiftAware;